<div class="flex flex-column">

  <p-dropdown
    [(ngModel)]="selectedSensorTypeOption"
    [options]="sensorTypeOptions | translateLabels | async"
    optionValue="value"
    styleClass="w-full"
  ></p-dropdown>

  <p-table
    #deviceMeasurementsTable
    *ngIf="selectedSensorTypeOption === 'deviceMeasurement'"
    [(first)]="deviceMeasurementsFirst"
    [(rows)]="deviceMeasurementsRows"
    [value]="deviceMeasurements"
    [totalRecords]="deviceMeasurements.length"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [paginator]="true"
    [globalFilterFields]="['name','device.serialNumber']"
    (selectionChange)="!$event || selectionChange.emit(deviceMeasurementToSensorIdentifier($event))"
    selectionMode="single"
    styleClass="p-datatable-striped mt-3"
    sortField="name"
  >
    <ng-template pTemplate="caption">
      <div class="flex">
        <span class="p-input-icon-right w-full">
          <i class="pi pi-search"></i>
          <input
            #deviceMeasurementsSearch
            [placeholder]="'common.search' | transloco"
            (input)="deviceMeasurementsTable.filterGlobal($event.target['value'], 'contains')"
            pInputText
            type="text"
            class="w-full"
          />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th class="w-18rem" pSortableColumn="device.serialNumber">
          {{'model.device' | transloco}}
          <p-sortIcon field="device.serialNumber"></p-sortIcon>
        </th>
        <th class="w-18rem" pSortableColumn="name">
          {{'model.sensor' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-measurement>
      <tr [pSelectableRow]="measurement">
        <td>
          <span class="p-column-title bold">{{'model.device' | transloco}}</span>
          {{measurement.device.serialNumber}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
          <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-table
    #assetMeasurementsTable
    *ngIf="selectedSensorTypeOption === 'assetMeasurement'"
    [(first)]="assetMeasurementsFirst"
    [(rows)]="assetMeasurementsRows"
    [value]="assetMeasurements"
    [totalRecords]="assetMeasurements.length"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [paginator]="true"
    [globalFilterFields]="['name','asset.alias']"
    (selectionChange)="!$event || selectionChange.emit(assetMeasurementToSensorIdentifier($event))"
    selectionMode="single"
    styleClass="p-datatable-striped mt-3"
    sortField="name"
  >
    <ng-template pTemplate="caption">
      <div class="flex">
        <span class="p-input-icon-right w-full">
          <i class="pi pi-search"></i>
          <input
            #deviceMeasurementsSearch
            [placeholder]="'common.search' | transloco"
            (input)="assetMeasurementsTable.filterGlobal($event.target['value'], 'contains')"
            pInputText
            type="text"
            class="w-full"
          />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th class="w-18rem" pSortableColumn="asset.alias">
          {{'model.asset' | transloco}}
          <p-sortIcon field="asset.alias"></p-sortIcon>
        </th>
        <th class="w-18rem" pSortableColumn="name">
          {{'model.sensor' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-measurement>
      <tr [pSelectableRow]="measurement">
        <td>
          <span class="p-column-title bold">{{'model.asset' | transloco}}</span>
          {{measurement.asset.alias}}
        </td>
        <td>
          <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
          <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-table
    #kpisTable
    *ngIf="selectedSensorTypeOption === 'kpi'"
    [(first)]="kpisFirst"
    [(rows)]="kpisRows"
    [value]="kpis"
    [totalRecords]="kpis.length"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [paginator]="true"
    [globalFilterFields]="['name']"
    (selectionChange)="!$event || selectionChange.emit(kpiToSensorIdentifier($event))"
    selectionMode="single"
    styleClass="p-datatable-striped mt-3"
    sortField="name"
  >
    <ng-template pTemplate="caption">
      <div class="flex">
        <span class="p-input-icon-right w-full">
          <i class="pi pi-search"></i>
          <input
            #deviceMeasurementsSearch
            [placeholder]="'common.search' | transloco"
            (input)="kpisTable.filterGlobal($event.target['value'], 'contains')"
            pInputText
            type="text"
            class="w-full"
          />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th class="w-18rem" pSortableColumn="name">
          {{'attribute.name' | transloco}}
          <p-sortIcon field="asset.alias"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-kpi>
      <tr [pSelectableRow]="kpi">
        <td>
          <span class="p-column-title bold">{{'model.asset' | transloco}}</span>
          {{kpi.name}}
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>
